/* esm.sh - use-sidecar@1.1.3/dist/es2015/config */
var o={onError:function(r){return console.error(r)}},n=function(r){Object.assign(o,r)};export{o as config,n as setConfig};
//# sourceMappingURL=config.mjs.map